import api from './api'

const resource = '/exam-results'

export default {
	
	create(payload) {
		return api.post(resource, payload)
	},
}